export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const UPLOAD_PROFILE_PIC = "UPLOAD_PROFILE_PIC";
export const UPLOAD_PROFILE_PIC_FAILURE = "UPLOAD_PROFILE_PIC_FAILURE";
export const UPLOAD_PROFILE_PIC_REQUEST = "UPLOAD_PROFILE_PIC_REQUEST";
export const AUTO_AUTH = "AUTO_AUTH"
